document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.gt_option a').forEach(function(el) {
    el.addEventListener('click', function (e) {
      const selectedLang = e.currentTarget.getAttribute('data-gt-lang');
      console.log('Language selected:', selectedLang);

      // Change HTML tag direction based on language
      const html = document.documentElement;
      if (selectedLang === 'ar') {
        html.setAttribute('lang', 'ar');
        html.setAttribute('dir', 'rtl');
        html.classList.add('translated-rtl');
      } else {
        html.setAttribute('lang', 'en');
        html.setAttribute('dir', 'ltr');
        html.classList.remove('translated-rtl');
      }
    });
  });
});
